//指定OBS服务相关信息：AK，SK，EndPoint
var Configuration = {
  AccessKeyId: 'FRMXQCPA4OCRVB98FKWQ',  //AK
  SecretKey: 'MTek9apznJHxIpwfUkFwX6aef4vRlInckBMPMuTv',        //SK
  EndPoint: 'https://hes.obs.cn-east-2.myhuaweicloud.com/',         //上传文件的路径
};


module.exports = Configuration;



// WEBPACK FOOTER //
// ./libs/OBS/Configuration.js